<template>
    <div
        v-if="
            !isButtonColorContrast(buttonColor, buttonTextColor) ||
            !isButtonColorContrast(backgroundColor, textColor) ||
            !isButtonColorContrast(backgroundColor, buttonColor)
        "
        class="border border-solid border-orange p-2 my-2 rounded"
        style="background-color: rgba(246, 153, 63, 0.23)"
    >
        <span class="text-sm font-bold">
            <i class="fas fa-palette"></i>
            {{ translate('color_contrast_warning_title', 'Color Contrast Warning') }}
        </span>
        <ul class="ml-2 my-2" style="list-style: none; padding: 0">
            <li
                v-if="!isButtonColorContrast(buttonColor, buttonTextColor)"
                class="text-sm flex items-center d-flex align-items-center"
            >
                <span class="inline-block mr-2">
                    -
                    {{
                        translate(
                            'color_contrast_button_text_warning',
                            'The button and text color look the same, which might make it hard to see.'
                        )
                    }}
                    <a @click.prevent="onChangeButtonAndTextColor" class="text-black" href="">{{
                        translate('color_contrast_try_this', 'Try this')
                    }}</a>
                </span>
                <span :style="{ backgroundColor: buttonColor }" class="recommeded-color"></span>
                &nbsp;+&nbsp;
                <span
                    :style="{
                        backgroundColor: getRecommendContrastColor(buttonColor, buttonTextColor)
                    }"
                    class="recommeded-color"
                ></span>
            </li>

            <li
                v-if="!isButtonColorContrast(backgroundColor, textColor)"
                class="text-sm flex items-center d-flex align-items-center"
            >
                <span class="inline-block mr-2">
                    -
                    {{
                        translate(
                            'color_contrast_background_text_warning',
                            'The background color and text look too similar, which could make reading difficult.'
                        )
                    }}
                    <a @click.prevent="onChangeBackgrounAndTextColor" class="text-black" href="">{{
                        translate('color_contrast_try_this', 'Try this')
                    }}</a>
                </span>
                <span :style="{ backgroundColor: backgroundColor }" class="recommeded-color"></span>
                &nbsp;+&nbsp;
                <span
                    :style="{
                        backgroundColor: getRecommendContrastColor(backgroundColor, textColor)
                    }"
                    class="recommeded-color"
                ></span>
            </li>

            <li
                v-if="!isButtonColorContrast(backgroundColor, buttonColor)"
                class="text-sm flex items-center d-flex align-items-center"
            >
                <span class="inline-block mr-2">
                    -
                    {{
                        translate(
                            'color_contrast_background_button_warning',
                            'The background color and button look similar, making it hard to distinguish them.'
                        )
                    }}
                    <a @click.prevent="onChangeBackgrounAndButtonColor" class="text-black" href="">{{
                        translate('color_contrast_try_this', 'Try this')
                    }}</a>
                </span>
                <span :style="{ backgroundColor: backgroundColor }" class="recommeded-color"></span>
                &nbsp;+&nbsp;
                <span
                    :style="{
                        backgroundColor: getRecommendContrastColor(backgroundColor, buttonColor)
                    }"
                    class="recommeded-color"
                ></span>
            </li>
        </ul>
    </div>
</template>

<script>
import ColorContrast from '../../../lib/color-contrast.js'

export default {
    props: {
        backgroundColor: {
            type: String
        },

        textColor: {
            type: String
        },

        buttonColor: {
            type: String
        },

        buttonTextColor: {
            type: String
        }
    },

    methods: {
        translate(key, msg) {
            if (typeof process.env.VUE_APP_IS_BACKEND !== 'undefined') {
                return msg
            }

            return this.$t(key)
        },

        isButtonColorContrast(bgColor, textColor) {
            const constrast = new ColorContrast(bgColor, textColor)

            return constrast.check() !== 'fail'
        },

        getRecommendContrastColor(bgColor, textColor) {
            const constrast = new ColorContrast(bgColor, textColor)
            return constrast.getRecommedColor()
        },

        onChangeButtonAndTextColor() {
            this.$emit('change-button-and-text-color', {
                buttonColor: this.buttonColor,
                buttonTextColor: this.getRecommendContrastColor(this.buttonColor, this.buttonTextColor)
            })
        },

        onChangeBackgrounAndTextColor() {
            this.$emit('change-background-and-text-color', {
                backgroundColor: this.backgroundColor,
                textColor: this.getRecommendContrastColor(this.backgroundColor, this.textColor)
            })
        },

        onChangeBackgrounAndButtonColor() {
            this.$emit('change-background-and-button-color', {
                backgroundColor: this.backgroundColor,
                buttonColor: this.getRecommendContrastColor(this.backgroundColor, this.buttonColor)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.recommeded-color {
    display: inline-block;
    border-radius: 9999px;
    border-width: 1px;
    border-color: #6b7280;
    border-style: solid;
    width: 1rem;
    height: 1rem;
}
</style>
